import { Component, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import templateContent from "./theme-switch.html";


class ThemeSwitchComponent extends Component {
	constructor () {
		super("themeSwitchComponent");
		this.addTemplate("", templateContent);
	}

	afterLoad () {
		this.showActiveTheme(this.getPreferredTheme());
			
		window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
			const storedTheme = this.getStoredTheme();

			if (storedTheme !== "light" && storedTheme !== "dark") {
				this.setTheme(getPreferredTheme());
			}
		});

		document.querySelectorAll("[data-bs-theme-value]").forEach(toggle => {
			toggle.addEventListener("click", () => {
				const theme = toggle.getAttribute("data-bs-theme-value");
				console.log({theme});
				
				this.setStoredTheme(theme);
				this.setTheme(theme);
				this.showActiveTheme(theme, true);
			});
		});
	}

	getStoredTheme () {
		return localStorage.getItem("userPreferredTheme");
	}

	setStoredTheme (theme) {
		localStorage.setItem("userPreferredTheme", theme);
	}
	
	getPreferredTheme () {
		const storedTheme = this.getStoredTheme();

		if (storedTheme) {
			return storedTheme;
		}
	
		return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
	}
	
	setTheme (theme) {
		if (theme === "auto") {
			document.documentElement.setAttribute("data-bs-theme", (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"));
		}
		else {
			document.documentElement.setAttribute("data-bs-theme", theme);
		}
	}
	
	init () {
		this.setTheme(this.getPreferredTheme());

	}
	
	showActiveTheme (theme, focus = false) {
		const themeSwitcher = document.querySelector("#bd-theme");
	
		if (!themeSwitcher) {
			return;
		}
	
		const themeSwitcherText = document.querySelector("#bd-theme-text");
		const activeThemeIcon = document.querySelector(".theme-icon-active i");
		const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`);
		const btnToActiveCheckIcon = btnToActive.querySelector(".bi.ms-auto");
		const classListOfActiveBtn = btnToActive.querySelector("i").classList;
	
		document.querySelectorAll("[data-bs-theme-value]").forEach(element => {
			element.classList.remove("active");
			element.setAttribute("aria-pressed", "false");
			element.querySelector(".bi.ms-auto").classList.add("d-none");
		});
	
		btnToActiveCheckIcon.classList.remove("d-none");
		btnToActive.classList.add("active");
		btnToActive.setAttribute("aria-pressed", "true");
		activeThemeIcon.classList = classListOfActiveBtn;

		const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`;
		themeSwitcher.setAttribute("aria-label", themeSwitcherLabel);
	
		if (focus) {
			themeSwitcher.focus();
		}
	}
}

const themeSwitchComponent = new ThemeSwitchComponent();

Shark.registerComponent(themeSwitchComponent);

export default themeSwitchComponent;
